module.exports = __webpack_public_path__ + "img/bus-white.d847efa4.webp";